import React from 'react'
import { useSelector } from 'react-redux';
import './BillTypeTemplateSummaryThermal.css';
import { getFilteredCashCard, hasCashCardFilter, groupCashCardByType } from '../cashCardFilterUtils';

function BillTypeTemplateSummaryPrint() {
    const ShiftBillTypeSummary = useSelector(
        (state) => state.posReportshiftSlice.billTypeSummary
      );
      const getBackgroundColor = (index) => {
        return index % 2 === 0 ? "#ffffff" : "#dfdfdf";
      };
    
      const decimalPosition = localStorage.getItem("decimalPosition");
      const {showSubHeaders, paymentTypeSplit, cashCardSplit, cardNameFilter, bankJournalFilter} = useSelector((state) => state.posReportshiftSlice);

      const cashCardFilterActive = hasCashCardFilter(cardNameFilter, bankJournalFilter);
      const { rows: filteredCashCardRows, total: filteredCashCardTotal } = getFilteredCashCard(
        ShiftBillTypeSummary?.cashAndCard?.list,
        cardNameFilter,
        bankJournalFilter
      );
      const cashCardRowsToShow = cashCardFilterActive
        ? filteredCashCardRows
        : ShiftBillTypeSummary?.cashAndCard?.list || [];
      const cashCardGroups = groupCashCardByType(cashCardRowsToShow);

      const getPaymentTypeBreakdown = (list) => {
        if (!list || list.length === 0) return [];
        const map = {};
        list.forEach((item) => {
          const pt = item?.paymentType || "Unknown";
          map[pt] = (map[pt] || 0) + (item?.amount || 0);
        });
        return Object.entries(map).map(([type, amount]) => ({ type, amount }));
      };

      const staffExpBreakdown = paymentTypeSplit ? getPaymentTypeBreakdown(ShiftBillTypeSummary?.staffExpense?.list) : [];
      const outletExpBreakdown = paymentTypeSplit ? getPaymentTypeBreakdown(ShiftBillTypeSummary?.outletExpense?.list) : [];

      const getAllExpenseBreakdown = () => {
        const map = {};
        const allLists = [
          ...(ShiftBillTypeSummary?.staffExpense?.list || []),
          ...(ShiftBillTypeSummary?.outletExpense?.list || []),
        ];
        allLists.forEach((item) => {
          const pt = (item?.paymentType || "Unknown").toUpperCase();
          map[pt] = (map[pt] || 0) + (item?.amount || 0);
        });
        return map;
      };

      const getAfterExpensesRows = () => {
        if (!paymentTypeSplit) return [];
        const cashCardList = ShiftBillTypeSummary?.cashAndCard?.list || [];
        const expMap = getAllExpenseBreakdown();
        const rows = [];
        cashCardList.forEach((cc) => {
          const typeName = (cc?.type || "").toUpperCase();
          if (typeName === "CASH") return;
          const expAmount = expMap[typeName] || 0;
          if (expAmount > 0) {
            rows.push({
              type: `${cc?.type} After Expenses`,
              amount: (cc?.amount || 0) - expAmount,
            });
          }
        });
        return rows;
      };

      const afterExpensesRows = getAfterExpensesRows();

      // Derive counts for main headers (shown without expanding details)
      const dineInCount = (
        ShiftBillTypeSummary?.dineIn?.count ??
        (Array.isArray(ShiftBillTypeSummary?.dineIn?.list)
          ? ShiftBillTypeSummary?.dineIn?.list.length
          : 0)
      );

      const takeAwayCount = (
        ShiftBillTypeSummary?.takeAway?.count ??
        (Array.isArray(ShiftBillTypeSummary?.takeAway?.list)
          ? ShiftBillTypeSummary?.takeAway?.list.length
          : 0)
      );

      const sumBy = (arr, key) =>
        Array.isArray(arr)
          ? arr.reduce((acc, it) => acc + (Number(it?.[key]) || 0), 0)
          : 0;

      const deliveryCountFromSales =
        ShiftBillTypeSummary?.sales?.list?.delivery?.count ?? null;
      const deliverySelfCount = sumBy(
        ShiftBillTypeSummary?.delivery?.selfDelivery?.list,
        "count"
      );
      const deliveryAggCount = sumBy(
        ShiftBillTypeSummary?.delivery?.aggregator?.list,
        "count"
      );
      const deliveryCount =
        deliveryCountFromSales ?? deliverySelfCount + deliveryAggCount;
  return (
    <div
    className="thermal-receipt-container"
    
  >
  
    <div className="bill-main-head bill-type-header">
      <h5>Bill Type</h5>
      <h5>Amount</h5>
    </div>
    <div
      className="bill-sub-head"
     
    >
      <h5>Cash & Card</h5>
      <h5>
        {(ShiftBillTypeSummary?.cashAndCard?.total ||0)?.toFixed(decimalPosition)}
      </h5>
    </div>
    {!showSubHeaders && cashCardSplit && cashCardGroups?.length > 0 && (
      <table>
        <tbody>
          {cashCardGroups.map((group, gi) => (
            <React.Fragment key={gi}>
              <tr>
                <td style={{ paddingLeft: "10px", fontSize: "11px", fontWeight: "bold", textTransform: "capitalize" }}>{group.type}</td>
                <td style={{ textAlign: "right", fontSize: "11px", fontWeight: "bold" }}>{group.total?.toFixed(decimalPosition)}</td>
              </tr>
              {group.items.map((r, i) => (
                (r?.cardName || r?.journalName) && (
                  <tr key={`${gi}-${i}`}>
                    <td style={{ paddingLeft: "20px", fontSize: "10px" }}>{[r?.cardName, r?.journalName].filter(Boolean).join(" - ")}</td>
                    <td style={{ textAlign: "right", fontSize: "10px" }}>{r?.amount?.toFixed(decimalPosition)}</td>
                  </tr>
                )
              ))}
            </React.Fragment>
          ))}
          {cashCardFilterActive && (
            <tr>
              <td style={{ paddingLeft: "10px", fontSize: "11px", fontWeight: "bold" }}>Selected Total</td>
              <td style={{ textAlign: "right", fontSize: "11px", fontWeight: "bold" }}>{filteredCashCardTotal?.toFixed(decimalPosition)}</td>
            </tr>
          )}
        </tbody>
      </table>
    )}
    {showSubHeaders && (
      <table>
        <thead >
          <tr>
            <th>Payment Method</th>
            <th>Amount</th>
            <th>Commission</th>
            <th>Balance</th>
          </tr>
        </thead>
        <tbody>
          {ShiftBillTypeSummary?.cashAndCard?.list !== undefined ? (
            ShiftBillTypeSummary?.cashAndCard?.list?.map((r, i) => (
              <tr key={i}>
                <td
                  style={{ borderBottom: "1px solid black", height: "29px" }}
                >
                  {r.type}
                </td>
                <td
                  style={{ borderBottom: "1px solid black", height: "29px" }}
                >
                  {r.amount?.toFixed(decimalPosition)}
                </td>
                <td
                  style={{ borderBottom: "1px solid black", height: "29px" }}
                >
                  {r.commission?.toFixed(decimalPosition)}
                </td>
                <td
                  style={{ borderBottom: "1px solid black", height: "29px" }}
                >
                  {r.balance?.toFixed(decimalPosition)}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={8}>NO DATA</td>
            </tr>
          )}
        </tbody>
      </table>
    )}
    {/* Moved: Staff Expense */}
    <div className="bill-sub-head">
      <h5>Sales</h5>
      <h5>
        {(ShiftBillTypeSummary?.sales?.total ||0)?.toFixed(decimalPosition)}
      </h5>
    </div>
    {showSubHeaders && (
      <table>
        <thead >
          <tr>
            <th>Type</th>
            <th>Order Count</th>
            <th>Amount</th>
          </tr>
        </thead>
         <tbody>
      {ShiftBillTypeSummary?.sales?.list ? (
        Object.entries(ShiftBillTypeSummary?.sales?.list).map(([type, details], i) => (
          <tr key={i}>
            <td style={{ borderBottom: "1px solid black", height: "29px" }}>
              {type}
            </td>
            <td style={{ borderBottom: "1px solid black", height: "29px" }}>
              {details.count}
            </td>
            <td style={{ borderBottom: "1px solid black", height: "29px" }}>
              {details.amount?.toFixed(decimalPosition)}
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={3}>NO DATA</td>
        </tr>
      )}
    </tbody>
      </table>
    )}
    {/* Dine In - show only if total > 0 */}
    {(ShiftBillTypeSummary?.dineIn?.total || 0) > 0 && (
      <>
        <div className="bill-sub-head">
          <h5>{`Dine In${dineInCount ? ` (${dineInCount})` : ''}`}</h5>
          <h5>
            {(ShiftBillTypeSummary?.dineIn?.total || 0)?.toFixed(decimalPosition)}
          </h5>
        </div>
        {showSubHeaders && (
          <table>
            <thead >
              <tr>
                <th>Bill No</th>
                <th>Date</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {ShiftBillTypeSummary?.dineIn?.list !== undefined ? (
                ShiftBillTypeSummary?.dineIn?.list?.map((r, i) => (
                  <tr key={i}>
                    <td>
                      {r?.billNo}
                    </td>
                    <td>
                      {r?.date}
                    </td>
                    <td>
                      {r?.amount?.toFixed(decimalPosition)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8}>NO DATA</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </>
    )}
    {/* Take Away - show only if total > 0 */}
    {(ShiftBillTypeSummary?.takeAway?.total || 0) > 0 && (
      <>
        <div className="bill-sub-head">
          <h5>{`Take Away${takeAwayCount ? ` (${takeAwayCount})` : ''}`}</h5>
          <h5>
            {(ShiftBillTypeSummary?.takeAway?.total || 0)?.toFixed(decimalPosition)}
          </h5>
        </div>
        {showSubHeaders && (
          <table>
            <thead >
              <tr>
                <th>Bill No</th>
                <th>Date</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {ShiftBillTypeSummary?.takeAway?.list !== undefined ? (
                ShiftBillTypeSummary?.takeAway?.list?.map((r, i) => (
                  <tr key={i}>
                    <td>
                      {r?.billNo}
                    </td>
                    <td>
                      {r?.date}
                    </td>
                    <td>
                      {r?.amount?.toFixed(decimalPosition)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8}>NO DATA</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </>
    )}
      <div
    className="bill-sub-head"
   
  >
    <h5>{`Delivery${deliveryCount ? ` (${deliveryCount})` : ''}`}</h5>
    <h5>
      {(ShiftBillTypeSummary?.delivery?.total||0)?.toFixed(decimalPosition)}
    </h5>
  </div>
    {showSubHeaders && (
      <div className="bill-sub2-head">
        <h5>Self Delivery</h5>
        <h5> {(ShiftBillTypeSummary?.delivery?.selfDelivery?.total || 0)?.toFixed(decimalPosition)}</h5>
      </div>
    )}
    {showSubHeaders && (
      <table>
        <thead >
          <tr>
            <th>Employee</th>
            <th>Order Count</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {ShiftBillTypeSummary?.delivery?.selfDelivery?.list !== undefined ? (
            ShiftBillTypeSummary?.delivery?.selfDelivery?.list?.map((r, i) => (
              <tr key={i}>
                <td
                  style={{ borderBottom: "1px solid black", height: "29px" }}
                >
                  {r.name}
                </td>
                <td
                  style={{ borderBottom: "1px solid black", height: "29px" }}
                >
                  {r.count}
                </td>
                <td
                  style={{ borderBottom: "1px solid black", height: "29px" }}
                >
                  {r.amount?.toFixed(decimalPosition)}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={8}>NO DATA</td>
            </tr>
          )}
        </tbody>
      </table>
    )}
    {showSubHeaders && (
      <div className="bill-sub2-head">
        <h5>Aggregator</h5>
        <h5>{(ShiftBillTypeSummary?.delivery?.aggregator?.total || 0)?.toFixed(decimalPosition)}</h5>
      </div>
    )}
    {showSubHeaders && (
      <table>
        <thead >
        <tr>
            <th>Employee</th>
            <th>Order Count</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {ShiftBillTypeSummary?.delivery?.aggregator?.list !== undefined ? (
            ShiftBillTypeSummary?.delivery?.aggregator?.list?.map((r, i) => (
              <tr key={i}>
                <td
                  style={{ borderBottom: "1px solid black", height: "29px" }}
                >
                  {r.name}
                </td>
                <td
                  style={{ borderBottom: "1px solid black", height: "29px" }}
                >
                  {r.count}
                </td>
                <td
                  style={{ borderBottom: "1px solid black", height: "29px" }}
                >
                  {r.amount?.toFixed(decimalPosition)}
                </td>
               
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={8}>NO DATA</td>
            </tr>
          )}
        </tbody>
      </table>
    )}
  <div
  className="bill-sub-head"
 
>
  <h5>Receipt</h5>
  <h5>
    {(ShiftBillTypeSummary?.receipt?.total || 0).toFixed(decimalPosition)}
  </h5>
</div>
{showSubHeaders && (
  <table>
    <thead >
      <tr>
        {/* <th>Description</th>
        <th>Amount</th> */}
      </tr>
    </thead>
    <tbody>
      {/* <tr>
        <td style={{ borderBottom: "1px solid black", height: "29px" }}>Sales</td>
        <td style={{ borderBottom: "1px solid black", height: "29px" }}>{ShiftBillTypeSummary?.receipt?.sales?.toFixed(decimalPosition)||"0.00"}</td>
      </tr>
      <tr>
      <td style={{ borderBottom: "1px solid black", height: "29px" }}>Delivery Partner</td>
      <td style={{ borderBottom: "1px solid black", height: "29px" }}>{ShiftBillTypeSummary?.receipt?.deliveryPartner?.toFixed(decimalPosition)||"0.00"}</td>
      </tr>
      <tr>
      <td style={{ borderBottom: "1px solid black", height: "29px" }}>Packaging Charge</td>
      <td style={{ borderBottom: "1px solid black", height: "29px" }}>{ShiftBillTypeSummary?.receipt?.packagingCharge?.toFixed(decimalPosition)||"0.00"}</td>
      </tr>
      <tr>
      <td >Delivery Charge</td>
      <td >{ShiftBillTypeSummary?.receipt?.deliveryCharge?.toFixed(decimalPosition)||"0.00"}</td>
      </tr> */}
      {ShiftBillTypeSummary?.receipt ? (
  Object.entries(ShiftBillTypeSummary?.receipt)
    .filter(([key]) => key !== "total") // Exclude the 'total' row
    .map(([key, value], i) => (
      <tr key={i}>
        <td style={{ borderBottom: "1px solid black", height: "29px" }}>
          {key === "sales" ? "Sales" : 
           key === "deliveryPartner" ? "Delivery Partner" : 
           key === "packagingCharge" ? "Packaging Charge" : 
           key === "deliveryCharge" ? "Delivery Charge" : key}
        </td>
        <td style={{ borderBottom: "1px solid black", height: "29px" }}>
          {value?.toFixed(decimalPosition) || "0.00"}
        </td>
      </tr>
    ))
) : (
  <tr>
    <td colSpan={2}>NO DATA</td>
  </tr>
)}

    </tbody>
  </table>
)}

<div
      className="bill-sub-head"
     
    >
      <h5>Tax</h5>
      <h5>
        {(ShiftBillTypeSummary?.tax?.total ||0)?.toFixed(decimalPosition)}
      </h5>
    </div>
    {showSubHeaders && (
      <table>
        <thead >
          <tr>
            <th>Tax Name</th>
            <th>Tax%</th>
            <th>Amount</th>
           
          </tr>
        </thead>
        <tbody>
          {ShiftBillTypeSummary?.tax?.list !== undefined ? (
            ShiftBillTypeSummary?.tax?.list?.map((r, i) => (
              <tr key={i}>
                <td
                  style={{ borderBottom: "1px solid black", height: "29px" }}
                >
                  {r.name}
                </td>
                <td
                  style={{ borderBottom: "1px solid black", height: "29px" }}
                >
                  {r.percentage}
                </td>
                <td
                  style={{ borderBottom: "1px solid black", height: "29px" }}
                >
                  {r.amount?.toFixed(decimalPosition)}
                </td>
              
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={8}>NO DATA</td>
            </tr>
          )}
        </tbody>
      </table>
    )}
    {/* Staff Expense (moved below Tax) */}
    <div className="bill-sub-head">
      <h5>Staff Expense</h5>
      <h5>
        {(ShiftBillTypeSummary?.staffExpense?.total||0)?.toFixed(decimalPosition) }
      </h5>
    </div>
    {!showSubHeaders && paymentTypeSplit && staffExpBreakdown.length > 0 && (
      <table>
        <tbody>
          {staffExpBreakdown.map((item, i) => (
            <tr key={i}>
              <td style={{ paddingLeft: "10px", fontSize: "11px" }}>{item.type}</td>
              <td style={{ textAlign: "right", fontSize: "11px" }}>{item.amount?.toFixed(decimalPosition)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
    {showSubHeaders && (
      <table>
        <thead >
          <tr>
            <th>Expense</th>
            <th>Emp</th>
            <th>Date</th>
            <th>Paid By</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {ShiftBillTypeSummary?.staffExpense?.list !== undefined ? (
            ShiftBillTypeSummary?.staffExpense?.list?.map((r, i) => (
              <tr key={i}>
                <td>{r.expense}</td>
                <td>{r.employee}</td>
                <td>{r.date}</td>
                <td>{r.paymentType}</td>
                <td>{r.amount?.toFixed(decimalPosition)}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={8}>NO DATA</td>
            </tr>
          )}
        </tbody>
      </table>
    )}
    {/* Outlet Expense (moved below Tax) */}
    <div className="bill-sub-head">
      <h5>Outlet Expense</h5>
      <h5>
        {(ShiftBillTypeSummary?.outletExpense?.total || 0)?.toFixed(decimalPosition)}
      </h5>
    </div>
    {!showSubHeaders && paymentTypeSplit && outletExpBreakdown.length > 0 && (
      <table>
        <tbody>
          {outletExpBreakdown.map((item, i) => (
            <tr key={i}>
              <td style={{ paddingLeft: "10px", fontSize: "11px" }}>{item.type}</td>
              <td style={{ textAlign: "right", fontSize: "11px" }}>{item.amount?.toFixed(decimalPosition)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
    {showSubHeaders && (
      <table>
        <thead >
          <tr>
            <th>Doc No</th>
            <th>Expense</th>
            <th>Paid By</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {ShiftBillTypeSummary?.outletExpense?.list !== undefined ? (
            ShiftBillTypeSummary?.outletExpense?.list?.map((r, i) => (
              <tr key={i}>
                <td>{r.docNo}</td>
                <td>{r.expense}</td>
                <td>{r.paymentType}</td>
                <td>{r.amount?.toFixed(decimalPosition)}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={8}>NO DATA</td>
            </tr>
          )}
        </tbody>
      </table>
    )}
    {ShiftBillTypeSummary?.cashAfterExpenses?.show && (
      <div className="bill-sub-head">
        <h5>Cash After Expenses</h5>
        <h5>
          {(ShiftBillTypeSummary?.cashAfterExpenses?.total || 0)?.toFixed(decimalPosition)}
        </h5>
      </div>
    )}
    {afterExpensesRows.length > 0 && afterExpensesRows.map((row, i) => (
      <div key={i} className="bill-sub-head">
        <h5 style={{ fontSize: "11px" }}>{row.type}</h5>
        <h5 style={{ fontSize: "11px" }}>{row.amount?.toFixed(decimalPosition)}</h5>
      </div>
    ))}
    {ShiftBillTypeSummary?.pettyCashInfo?.show && (
      <div className="bill-sub-head">
        <h5>Petty Cash</h5>
        <h5>
          {(ShiftBillTypeSummary?.pettyCashInfo?.remaining || 0)?.toFixed(decimalPosition)}
        </h5>
      </div>
    )}
    {showSubHeaders && ShiftBillTypeSummary?.pettyCashInfo?.show && (
      <table>
        <thead>
          <tr>
            <th>Description</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Balance</td>
            <td>{(ShiftBillTypeSummary?.pettyCashInfo?.balance || 0)?.toFixed(decimalPosition)}</td>
          </tr>
          <tr>
            <td>Spent</td>
            <td>{(ShiftBillTypeSummary?.pettyCashInfo?.spent || 0)?.toFixed(decimalPosition)}</td>
          </tr>
          <tr>
            <td style={{ fontWeight: "bold" }}>Remaining</td>
            <td style={{ fontWeight: "bold" }}>{(ShiftBillTypeSummary?.pettyCashInfo?.remaining || 0)?.toFixed(decimalPosition)}</td>
          </tr>
        </tbody>
      </table>
    )}
    <div
      className="bill-sub-head"
      
    >
      <h5>Device</h5>
      <h5>
        {(ShiftBillTypeSummary?.device?.total ||0)?.toFixed(decimalPosition)}
      </h5>
    </div>
    {showSubHeaders && (
      <table>
        <thead >
          <tr>
            <th>Device Name</th>
            <th>Order Count</th>
            <th>Amount</th>
           
          </tr>
        </thead>
        <tbody>
          {ShiftBillTypeSummary?.device?.list !== undefined ? (
            ShiftBillTypeSummary?.device?.list?.map((r, i) => (
              <tr key={i}>
                <td
                  style={{ borderBottom: "1px solid black", height: "29px" }}
                >
                  {r.employeeName}
                </td>
                <td
                  style={{ borderBottom: "1px solid black", height: "29px" }}
                >
                  {r.count}
                </td>
                <td
                  style={{ borderBottom: "1px solid black", height: "29px" }}
                >
                  {r.amount?.toFixed(decimalPosition)}
                </td>
              
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={8}>NO DATA</td>
            </tr>
          )}
        </tbody>
      </table>
    )}

  
  
  </div>
  )
}

export default BillTypeTemplateSummaryPrint